import apiClient from 'utilities/apiClient';

export const users = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.admin}/${url}`, payload, true);
};
